import {
  Autocomplete,
  Button,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "../../../../hooks";
import { fetchData } from "../../../helpers/getData/fetchData";
import { TableLayout } from "../../../layout/TableLayout";
import { columnsByStartup } from "./column";

export const SearchByStartup = ({ handleEdit, setDivestmentData, divestmentData }) => {
  const { t } = useTranslation("global");
  const [formValues, handleInputChange] = useForm({ startupName: "" });

  const { startupName } = formValues;

  const [startupList, setStartupList] = useState(null);


  useEffect(() => {
    fetchData(setStartupList, "/startups", t);
  }, [t]);

  const handleClic = () => {
    const id = startupList.find((user) => user.name === startupName).id;
    fetchData(setDivestmentData, `/divestment/byStartupId?startup=${id}`, t);
  };

  return (
    <Stack direction="column" width="100%" gap={0}>
      {startupList ? (
        <>
          <Typography variant="overline" color="secondary">
            {t("search.byStartup")}
          </Typography>
          <Stack
            direction="row"
            flexWrap="wrap"
            gap={2}
            width="100%"
            justifyContent="space-between"
          >
            <Autocomplete
              disablePortal
              options={startupList.map((startup) => startup.name)}
              size="small"
              renderInput={(params) => (
                <TextField {...params} variant="outlined" name="startupName" />
              )}
              value={startupName}
              onSelect={handleInputChange}
              required
              sx={{ width: "80%" }}
            />
            <Button
              sx={{ width: "140px" }}
              onClick={handleClic}
              variant="contained"
            >
              {t("search.search")}
            </Button>
          </Stack>
        </>
      ) : (
        <CircularProgress />
      )}
      {divestmentData && (
        <Stack mt={2}>
          <TableLayout
            rows={divestmentData}
            columns={columnsByStartup(t, handleEdit)}
            title="noTitle"
          />
        </Stack>
      )}
    </Stack>
  );
};
